import React from "react";
import TableText from "@/components/table/TableText";
import { numConvert, calculation, sum } from "@/method";
import _ from 'lodash'
import moment from 'moment'

const totalIndex = [];
export const weeks = {
    0: "星期日",
    1: "星期一",
    2: "星期二",
    3: "星期三",
    4: "星期四",
    5: "星期五",
    6: "星期六",
};
const keys = new Array(31).fill(1).map((x, i) => `m${i + 1}`);
export default (data, { date, last, e4_2_4 }) => {
    keys.forEach((name, i) => {
        data[2][name] = _.get(e4_2_4, `${i + 1}.rn`, 0) || 0;
        data[3][name] = _.get(e4_2_4, `${i + 1}.rev`, 0) || 0;
        data[4][name] = _.get(e4_2_4, `${i + 1}.nextRn`, 0) || 0;
        data[5][name] = _.get(e4_2_4, `${i + 1}.nextRev`, 0) || 0;
        data[6][name] = _.get(e4_2_4, `${i + 1}.afterRn`, 0) || 0;
        data[7][name] = _.get(e4_2_4, `${i + 1}.afterRev`, 0) || 0;
    });
    // Pickup总计
    keys.forEach((name, i) => {
        data[0][name] = sum([
            data[2][name],
            data[4][name],
            data[6][name]
        ]);
        data[1][name] = sum([
            data[3][name],
            data[5][name],
            data[7][name]
        ]);
    });

    // 当月Total Pickup
    data.forEach((item, i) => {
        data[i].total = keys.reduce((a, b, i) => a += numConvert(item[b]), 0).toFixed(2);
        // 当月收官情况
        if (i > 1) {
            data[i].msc = sum([
                data[i].total,
                data[i].otb
            ]);
        }
    });
    return data
}

export const columns = (onChange, date, print) => {
    // 获取当月天数
    const days = moment(date).daysInMonth();
    return [
        {
            title: ``,
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: !print && "left",
            width: 100,
            render: (text, record, index) => {
                if (index % 2) {
                    return {
                        props: {
                            rowSpan: 0
                        }
                    }
                }
                const props = {
                    text,
                    index,
                    type: 'text',
                    name: "name",
                    onChange,
                    totalIndex,
                };
                return {
                    props: {
                        rowSpan: 2
                    },
                    children: <TableText data={props} />
                }
            }
        }, {
            title: `星期`,
            align: "center",
            fixed: !print && "left",
            width: 150,
            children: [{
                title: `Pickup日期`,
                align: "center",
                fixed: !print && "left",
                width: 150,
                dataIndex: 'type',
                key: 'type',
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'text',
                        name: "type",
                        onChange,
                        totalIndex,
                    };
                    return (
                        <TableText data={props} />
                    )
                }
            }]
        },
        ...new Array(days).fill(1).reduce((a, b, i) => {
            return [
                ...a,
                {
                    title: weeks[moment(`${date}-${i + 1}`).day()],
                    align: "center",
                    children: [{
                        title: moment(`${date}-${i + 1}`).format('MM-D'),
                        dataIndex: `m${i + 1}`,
                        key: `m${i + 1}`,
                        align: "center",
                        width: 120,
                        render: (text, record, index) => {
                            const props = {
                                text,
                                index,
                                type: 'number',
                                name: `m${i + 1}`,
                                onChange,
                                totalIndex,
                            };
                            return (
                                <TableText data={props} />
                            )
                        }
                    }]
                }
            ]
        }, []),
        {
            title: `当月Total Pickup`,
            dataIndex: 'total',
            key: 'total',
            align: "center",
            width: 120,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'number',
                    name: "total",
                    onChange,
                    totalIndex,
                };
                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `截止到上月底时的OTB情况`,
            dataIndex: 'otb',
            key: 'otb',
            align: "center",
            width: 120,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: print ? 'number' : index > 1 ? 'inputNumber' : '',
                    name: "otb",
                    onChange,
                    totalIndex,
                };
                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `当月收官情况`,
            dataIndex: 'msc',
            key: 'msc',
            align: "center",
            width: 120,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: index > 1 ? 'number' : "",
                    name: "msc",
                    onChange,
                    totalIndex,
                };
                return (
                    <TableText data={props} />
                )
            }
        }
    ]
}


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2/4.2.5/compute.js